import { QueryClient } from '@tanstack/react-query';
import {
  SUGGESTED_ACTION_TYPE,
  SuggestedActionsResponse,
  SuggestedActionType,
} from 'router/subrouters/DataRoom/models/Dashboard';
import { SUGGESTED_ACTIONS_QUERY_KEY } from '../../hooks/useSuggestedActionsQuery';

export const removeActiveSuggestedActionFromData = (
  oldData: SuggestedActionsResponse,
  types: SuggestedActionType[],
) => ({
  ...oldData,
  active: oldData.active.filter((item) => !types.includes(item.type)),
});

export const removeActiveSuggestedAction = (
  queryClient: QueryClient,
  types: SuggestedActionType[] = [],
) => {
  queryClient.setQueriesData<SuggestedActionsResponse>(
    { queryKey: [SUGGESTED_ACTIONS_QUERY_KEY] },
    (oldData) => {
      if (!oldData) return oldData;

      return removeActiveSuggestedActionFromData(oldData, types);
    },
  );
};

export const isSecureLinkSuggestion = (type: SuggestedActionType) =>
  type === SUGGESTED_ACTION_TYPE.SECURE_LINKS_EXPIRING;

export const isNoFaqsSuggestion = (type: SuggestedActionType) =>
  type === SUGGESTED_ACTION_TYPE.NO_FAQS;

export const isUnrepliedQuestionsSuggestion = (type: SuggestedActionType) =>
  type === SUGGESTED_ACTION_TYPE.UNREPLIED_QUESTIONS;
